import { ChangeDetectionStrategy, Component, HostBinding, ViewEncapsulation } from "@angular/core";
import { MatLegacyDialogRef as MatDialogRef } from "@angular/material/legacy-dialog";
import { Store } from "@ngrx/store";
import {
	CoreState,
	CUSTOMER_MANAGEMENT_ROUTE,
	CustomerManagementAction,
	CustomerManagementSelector,
} from "@obg/ngx.core";
import { TranslationSelector } from "@obg/ngx.core.content";
import { RouteAction } from "@obg/ngx.router";
import { ignoreNil } from "@obg/rxjs";
import { Observable } from "rxjs";
import { map, switchMap, take } from "rxjs/operators";

@Component({
	selector: "obg-m-login-yearly-review",
	templateUrl: "./login-yearly-review.container.html",
	styleUrls: ["./login-yearly-review.container.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
	encapsulation: ViewEncapsulation.None,
})
export class LoginYearlyReviewContainer {
	@HostBinding("class.obg-m-login-yearly-review") hostClass = true;

	welcomeMessageTranslation$: Observable<string>;

	constructor(
		private store: Store<CoreState>,
		private customerManagementAction: CustomerManagementAction,
		private translationSelector: TranslationSelector,
		private dialogRef: MatDialogRef<LoginYearlyReviewContainer>
	) {
		this.welcomeMessageTranslation$ = this.store.select(CustomerManagementSelector.getCustomer).pipe(
			ignoreNil(),
			take(1),
			map((customer) => customer.profile.firstName),
			switchMap((firstName) =>
				this.store.pipe(
					this.translationSelector.getByKey$("kyc-verify-popup.annual-review-welcoming-message", {
						user: firstName,
					})
				)
			)
		);
	}

	onReviewDetailsClick(): void {
		this.store.dispatch(this.customerManagementAction.updateProfileValidation());
		this.store.dispatch(RouteAction.navigate(CUSTOMER_MANAGEMENT_ROUTE.myProfile));

		this.dialogRef.close();
	}
}
